/* Theme = the OS setting, nothing else. Sets <html data-theme> and keeps it
   in sync when the OS flips. The same logic runs once inline in
   public/index.html before first paint so there is no flash. */

const CANVAS = { dark: "#0b0c0f", light: "#ffffff" };

export const applyTheme = () => {
  const light =
    window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches;
  const theme = light ? "light" : "dark";
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.style.backgroundColor = CANVAS[theme];
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", CANVAS[theme]);
};

export const watchSystemTheme = () => {
  if (!window.matchMedia) return;
  window
    .matchMedia("(prefers-color-scheme: light)")
    .addEventListener("change", applyTheme);
};
